module.exports = __webpack_public_path__ + "static/img/UOOYA_BOOL-8.9fbaf38.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/issue11/04/UOOYA_BOOL-8.jpg
// module id = R7aW
// module chunks = 7